// 展平嵌套的虚拟节点
function flattenVNodes(vnodes) {
    return vnodes.flatMap(vnode => (Array.isArray(vnode.children) ? flattenVNodes(vnode.children) : vnode));
}

export { flattenVNodes };
